import React from 'react'

import {
    Button,
} from 'antd'

class Deliveries extends React.Component{

    render(){
        return(
            <div style={{margin: 16, background: "white"}}>
                <Button
                            type="primary"
                            //onClick={()=>window.open('/docs/edit')}
                        > Placeholder For Now </Button>
            </div>
        )
    }

    constructor(props){
        super(props)

        this.state = {
            placeHolder: []
        }
    }

    componentWillMount(){

    }

}

export default Deliveries


// WEBPACK FOOTER //
// ./src/components/deliveries/index.js